export type CampaignQuoteModel = {
  agency_id?: number,
  agency_payment_method_id?: number,
  authorization_sent?: boolean,
  authorized?: boolean,
  builder_version?: number,
  cache_key: number,
  campaign_id?: number,
  campaign_quote_template_id?: number,
  invalidItems?: Array<{
    campaign_quote_item_id: number,
    current_price_inc_fee: number,
    current_price: number,
    difference: number,
    display_title: string,
    options_string: string,
    original_price_inc_fee: number,
    original_price: number,
    processing_fee: number,
    title: string,
  }>,
  dates?: {
    created: {
      date_time: string,
    },
  },
  hidden?: boolean,
  id: number,
  links?: {
    pdf: string,
  },
  locked: boolean,
  priority_campaign_user_ids?: number[],
  recipient_address?: string,
  recipient_email?: string,
  recipient_name?: string,
  recipient_phone?: string,
  status_id?: number,
  title: string,
  total: number,
  void?: boolean,
}

export type CampaignQuoteRequestOptions = {
  include_campaign_quote_agency_payment_method?: boolean,
  include_campaign_quote_campaign?: boolean,
  include_campaign_quote_campaign_items?: boolean,
  include_campaign_quote_document_signers?: boolean,
  include_campaign_quote_invoices?: boolean,
  include_campaign_quote_items?: boolean,
  include_campaign_quote_links?: boolean,
  include_campaign_quote_orders?: boolean,
  include_campaign_quote_sections?: boolean,
  include_campaign_quote_status?: boolean,
  include_campaign_quote_priority_campaign_user_ids?: boolean,
}

export type CampaignQuoteStatusKeys = 'approved' | 'awaiting_review' | 'pending'

const state = {
  agency_payment_method_id: undefined,
  campaign_id: undefined,
  id: null,
  recipient_address: '',
  recipient_email: '',
  recipient_name: '',
  recipient_phone: '',
  status_id: undefined,
  title: '',
  void: false,
}

export const requiredFields = [
  { key: 'title' },
]

export default state
